// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_BuscarFormasPagamentoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /agenda/buscar_formas_pagamento
 *
 * Returns a list of payment methods (formas de pagamento).
 *
 * NON-CANON migration: Original response was {success, formas_pagamento}.
 * Now uses canonical envelope with {success, dados, error}.
 *
 * @see Agenda_BuscarFormasPagamentoRow
 * @see Formas_pagamento_model::busca_formas_pagamento()
 */
import type { Agenda_BuscarFormasPagamentoRow } from './Agenda_BuscarFormasPagamentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Agenda_BuscarFormasPagamentoResponseDados {
formas_pagamento: Agenda_BuscarFormasPagamentoRow[]
}

export type Agenda_BuscarFormasPagamentoResponse = ApiResponse<Agenda_BuscarFormasPagamentoResponseDados>;

registerResponseContract('Agenda_BuscarFormasPagamentoResponse', {
  formas_pagamento: {
    type: 'array',
    required: true,
    items: {
      forma_pagamento_id:                  { type: 'number',  required: true },
      forma_pagamento_possui_taxas:        { type: 'number',  required: false },
      forma_pagamento_aceita_parcelado:    { type: 'number',  required: false },
      forma_pagamento_nome:                { type: 'string',  required: true },
      forma_pagamento_taxa_mensal:         { type: 'number',  required: false },
      forma_pagamento_taxa_transacao:      { type: 'number',  required: false },
      forma_pagamento_taxa_transacao_tipo: { type: 'number',  required: false },
      background_color:                    { type: 'string',  required: false },
      forma_pagamento_codigo:              { type: 'string',  required: false },
      forma_pagamento_parcelas_max:        { type: 'number',  required: false },
      forma_pagamento_dias_para_receber:   { type: 'number',  required: false },
    },
  },
})
